export const forumFaq = [
	{
		id: 1,
		question: "How do I create a new thread?",
		answer: "To create a new thread, navigate to the relevant forum section and click on the 'New Thread' button. Fill in the title and content of your post, and then click 'Submit' to post it.",
	},
	{
		id: 2,
		question: "How can I reply to a post?",
		answer: "To reply to a post, open the thread you want to respond to and click on the 'Reply' button. Type your response in the text box provided and click 'Submit' to post your reply.",
	},
	{
		id: 3,
		question: "How do I edit or delete my post?",
		answer: "To edit your post, click on the 'Edit' button located at the bottom of your post. Make the necessary changes and click 'Save'. To delete your post, click on the 'Delete' button and confirm your decision.",
	},
	{
		id: 4,
		question: "How can I report inappropriate content?",
		answer: "If you come across inappropriate content, click on the 'Report' button usually found near the post. Provide a reason for reporting and submit. Moderators will review your report and take appropriate action.",
	},
	{
		id: 5,
		question: "How do I customize my profile?",
		answer: "To customize your profile, go to your user settings by clicking on your username or profile picture. From there, you can update your avatar, bio, contact information, and other personal details.",
	},
];
